module.exports = __webpack_public_path__ + "images/mobile/icon-attachment@2x-c5131b48ba107cb8b351cc3760b27b7d.png";